// src/components/ConnectWalletPrompt.js

import React from 'react';

const IMAGES = [
  'https://i.imgur.com/rq78rvr.png',
  'https://i.imgur.com/fMMZafs.png',
  'https://i.imgur.com/eonJNix.png',
  'https://i.imgur.com/v8CAH5R.png',
];

const COMPANY_LOGO_URL = 'https://d3omtvnlh9xgzy.cloudfront.net/core/coin-default.png';

const bgImg = IMAGES[Math.floor(Math.random() * IMAGES.length)];

const ConnectWalletPrompt = ({ onRequestConnectWallet }) => {
  return (
    <div className="game-login">
      <div className="game-login-art" aria-hidden="true">
        <div
          className="bg-holder"
          style={{
            backgroundImage: `url("${bgImg}")`,
            backgroundPosition: '50% 30%',
          }}
        />
      </div>
      <div className="game-login-panel">
        <div className="game-login-card">
          <div className="game-micro mb-2">wallet gate</div>
          <img className="game-login-logo" src={COMPANY_LOGO_URL} alt="company logo" />
          <h1 className="game-login-title">Catsaspell</h1>
          <p className="game-login-copy">
            Connect an approved wallet to enter the operator console.
          </p>
          <button
            onClick={onRequestConnectWallet}
            className="wallet-adapter-button wallet-adapter-button-trigger"
            tabIndex={0}
            type="button"
          >
            Select Wallet
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectWalletPrompt;
